"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function RatingIcon(props) {
    return (React.createElement("svg", { width: props.size, height: props.size, viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("linearGradient", { id: props.id },
                React.createElement("stop", { offset: props.percent, stopColor: props.fillColor }),
                React.createElement("stop", { offset: props.percent, stopColor: props.unfillColor })),
            extractSVG(props))));
}
exports.default = RatingIcon;
function extractSVG(props) {
    // If no svg was given then return a default
    if (props.icon === undefined)
        return getDefault(props);
    var elems = [];
    var elemsCopy = [];
    if (Array.isArray(props.icon.props.children)) {
        props.icon.props.children.forEach(function (element) {
            if (element.type === 'g') {
                elems = elems.concat(searchG(element));
            }
        });
    }
    else {
        if (props.icon.props.children.type === 'g') {
            elems = elems.concat(searchG(props.icon.props.children));
        }
    }
    elems.forEach(function (elem) {
        var elemCopy = {};
        Object.assign(elemCopy, elem);
        Object.assign(elemCopy, {
            props: __assign(__assign({}, elem.props), { fill: props.fill, className: "" + (props.className || "") })
        });
        elemsCopy.push(elemCopy);
    });
    if (elemsCopy.length === 0)
        return getDefault(props);
    return elemsCopy;
}
function searchG(g) {
    var elems;
    elems = [];
    if (Array.isArray(g.props.children)) {
        g.props.children.forEach(function (element) {
            if (element.type === 'g') {
                elems = elems.concat(searchG(element));
            }
            else {
                elems.push(element);
            }
        });
    }
    else if (g.props.children.type === 'g') {
        elems = elems.concat(searchG(g.props.children));
    }
    else {
        elems.push(g.props.children);
    }
    return elems;
}
function getDefault(props) {
    return (React.createElement("path", { d: "M11.3590965,9.92348558 L12.8686084,14.8136451 C12.8686084,14.8136451 13.7409887,16.8684256 11.9642082,15.5410674 C10.3364185,14.3248337 8.01007116,12.4882117 8.01007116,12.4882117 C8.01007116,12.4882117 5.57067376,14.3650567 3.95791384,15.6044697 C2.33535189,16.8520638 3.16460325,14.749561 3.16460325,14.749561 L4.66627354,9.91734987 L0.587977488,6.8072275 C0.587977488,6.8072275 -0.890167951,5.75802138 0.840869744,5.75802138 C2.83329478,5.75802138 5.94772501,5.75938487 5.94772501,5.75938487 L7.57486123,0.454724161 C7.57486123,0.454724161 7.70163409,0 8.02183359,0 C8.36229061,0 8.4759941,0.488129684 8.4759941,0.488129684 L10.0841797,5.76347534 C10.0841797,5.76347534 13.1672435,5.75802138 15.1609755,5.75802138 C16.7992207,5.75802138 15.5334524,6.73837122 15.5334524,6.73837122 L11.3590965,9.92348558 Z", fill: props.fill, className: "" + (props.className || '') }));
}
